<template>
    <div class="v-tour">
        <slot :current-step="currentStep"
              :steps="steps"
              :previous-step="previousStep"
              :next-step="nextStep"
              :stop="stop"
              :isFirst="isFirst"
              :isLast="isLast">
            <transition name="fade">
                <v-step
                        v-if="currentStep === index"
                        v-for="(step, index) of steps"
                        :key="index"
                        :step="step"
                        :previous-step="previousStep"
                        :next-step="nextStep"
                        :stop="stop"
                        :isFirst="isFirst"
                        :isLast="isLast"
                        :index="index"
                        :total="steps.length"></v-step>
            </transition>
        </slot>
    </div>
</template>

<script>
    const DEFAULT_CALLBACKS = {
        onStart: () => {
        },
        onPreviousStep: (currentStep) => {
        },
        onNextStep: (currentStep) => {
        },
        onStop: () => {
        }
    }

    const DEFAULT_OPTIONS = {
        useKeyboardNavigation: true,
        startTimeout: 0
    }

    const DEFAULT_STEP_OPTIONS = {
        placement: 'bottom'
    }

    const KEYS = {
        ARROW_RIGHT: 39,
        ARROW_LEFT: 37,
        ESCAPE: 27
    }

    export default {
        name: 'v-tour',
        props: {
            name: {
                type: String
            },
            options: {
                type: Object,
                default: () => {
                    return DEFAULT_OPTIONS
                }
            },
            callbacks: {
                type: Object,
                default: () => {
                    return DEFAULT_CALLBACKS
                }
            }
        },
        data() {
            return {
                currentStep: -1,
                steps: []
            }
        },
        mounted() {
            this.$tours[this.name] = this

            if (this.customOptions.useKeyboardNavigation) {
                window.addEventListener('keyup', this.handleKeyup)
            }
        },
        beforeDestroy() {
            // Remove the keyup listener if it has been defined
            if (this.customOptions.useKeyboardNavigation) {
                window.removeEventListener('keyup', this.handleKeyup)
            }
        },
        computed: {
            // Allow us to define custom options and merge them with the default options.
            // Since options is a computed property, it is reactive and can be updated during runtime.
            customOptions() {
                return {
                    ...DEFAULT_OPTIONS,
                    ...this.options
                }
            },
            customCallbacks() {
                return {
                    ...DEFAULT_CALLBACKS,
                    ...this.callbacks
                }
            },
            // Return true if the tour is active, which means that there's a VStep displayed
            isRunning() {
                return this.currentStep > -1 && this.currentStep < this.numberOfSteps
            },
            isFirst() {
                return this.currentStep === 0
            },
            isLast() {
                return this.currentStep === this.steps.length - 1
            },
            numberOfSteps() {
                return this.steps.length
            }
        },
        methods: {
            start() {
                // Wait for the DOM to be loaded, then start the tour
                setTimeout(() => {
                    this.updateSteps()
                    this.customCallbacks.onStart()
                    this.currentStep = 0
                }, this.customOptions.startTimeout)
            },
            previousStep() {
                if (this.currentStep > 0) {
                    this.customCallbacks.onPreviousStep(this.currentStep)
                    this.currentStep--
                }
            },
            nextStep() {
                if (this.currentStep < this.numberOfSteps - 1 && this.currentStep !== -1) {
                    this.customCallbacks.onNextStep(this.currentStep)
                    this.currentStep++
                }
            },
            stop() {
                this.customCallbacks.onStop()
                this.currentStep = -1
            },
            handleKeyup(e) {
                // TODO: debug mode
                // console.log('[Vue Tour] A keyup event occured:', e)
                switch (e.keyCode) {
                    case KEYS.ARROW_RIGHT:
                        this.nextStep()
                        break
                    case KEYS.ARROW_LEFT:
                        this.previousStep()
                        break
                    case KEYS.ESCAPE:
                        this.stop()
                        break
                }
            },
            updateSteps() {
                var nodelist = document.querySelectorAll('[tour]')
                var steps = Array.prototype.map.call(nodelist, el => ({
                    target: `[tour="${el.getAttribute('tour')}"]`,
                    content: el.getAttribute('tour-content'),
                    title: el.getAttribute('tour-title')
                }))
                steps.sort((a, b) => a.target.localeCompare(b.target))
                this.steps = steps
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/VTour.vue